import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Redirect, withRouter } from 'react-router'

import {
	getAccountData,
	getUserData,
	openModal,
	clearPending,
	openHeaderTab,
	updateKeyboardHeight,
	setDeviceToken,
	touchAccount,
	clearActivation,
	clearUnsubscribeData,
	cancelPremium,
	getPlanAndCurrencyInfo,
	checkForNewChats,
	getWellness,
	purgeData
} from 'state/actions'

import Socket from 'components/socket/socket'

import Header from 'layout/header/header'
import Dock from 'layout/dock/dock'

import Main from './components/main/main'
import ErrorBoundary from './components/error-boundary/error-boundary'

import {
	getCurrentAccount,
	getUserRoles,
	getCurrentUser,
	isCurrentUserGuest,
	isPremium
} from 'state/selectors'

import {
	getNotificationUrl,
	isMobile,
	doToken,
	scaleFactor,
	scrollToTop,
	doDeepLink,
	isBlockedPremiumAccount,
	toggleMobileControls
} from 'utils'

import {
	isCordova
} from 'env'

import MobileFooter from 'components/mobile/mobile-footer'
import { MainContext } from 'context'

import ScreenCover from 'components/mobile/screen-cover'

import axios from 'axios'
import moment from 'moment'

class App extends Component {
	constructor(props) {
		super(props)

		this.blockScrollResponse = false
		this.hasCheckedForPending = false
		this.lastTimeGettingAccountData = null
		this.timeAtMount = moment()
		this.contextObject = null
		this.hasActivatedUpgradeModal = false
		this.hasActivatedPremiumBlockModal = false
		this.hasCheckedForStylesheetSwap = false
		this.isChat = false

		// To solve race conditions when loading user/account data below 
		this.hasLoadedAccountData = false
		this.hasLoadedUserData = false

		this.wellnessTimerInterval = null
		this.wellnessLastCheckedHour = null

		window.dirtyInputs = [] // so we don't background-reload with pending text.

		doToken('get', null, response => {
			const {
				token,
			} = response

			// Temporary - so existing tokens don't fuck up for people.
			let userId = response.userId ? response.userId : this.props.userId

			if (token) {
				axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

				this.setState({
					token
				})
			}

			const {
				getUserData,
				openModal,
				history,
				location
			} = this.props

			this.isChat = location.pathname.endsWith('/chat')

			if (userId) {
				this.getAccountData({
					...this.props,
					campaign: window.campaign
				}, _ => {
					const {
						currentAccount,
						match,
						history,
						location
					} = this.props

					this.hasLoadedAccountData = true

					if (this.hasLoadedUserData) {
						this.setState({
							isLoadingInitData: false
						})
					}

					// Might return null (we still want the above executed)
					if (currentAccount) {
						if (currentAccount.slug !== match.params.account_slug) {
							let currentUrl = location.pathname
							currentUrl = currentUrl.replace(match.params.account_slug, currentAccount.slug)
							history.replace(currentUrl)
						}

						if (!this.hasCheckedForPending) {
							this.checkForPendingNotificationOrInvitation()
						}
					}
				})

				getUserData(userId, (error, isNetworkError) => {
					this.hasLoadedUserData = true

					if (this.hasLoadedAccountData) {
						this.setState({
							isLoadingInitData: false
						})
					}

					if (!this.hasCheckedForPending) {
						this.checkForPendingNotificationOrInvitation()
					}

					if (error) {
						let message

						if (isNetworkError) {
							message = "We can't talk to our server. Is your internet okay?"
						} else {
							message = "Something seems to have broken. If issues persist, perhaps log out and back in?"
						}

						openModal('error', null, { message })
					}
				}, this.props.token ? this.props.token : null)
			} else {
				window.initiallyRequestedLocation = location
				history.push("/auth/login")
			}
		})

		this.state = {
			sidebarHidden: false,
			isLoaderVisible: false,
			isLight: false,
			isLoadingInitData: true,
			token: null,
			isScrollHandlerBlocked: false,
		}
	}

	checkForPendingNotificationOrInvitation = (soft = false) => {
		// if soft = true, don't show an error for a missing item

		const {
			pendingInvitation,
			pendingNotification,
			currentAccount,
			userId,
			history,
			clearPending,
			openModal,
			allEntities,
			emailValidation,
			clearActivation
		} = this.props

		if (pendingInvitation) {
			openModal('accept', 'pending_invitation', { invitation: pendingInvitation })
		} else if (pendingNotification) {
			if (userId === pendingNotification.recipient_id) {
				this.setState({
					isLoaderVisible: false
				})

				let newURL

				try {
					newURL = getNotificationUrl(allEntities, pendingNotification, currentAccount)
				} catch (error) {
					if (!soft) {
						openModal('error', null, { message: 'The item this notification references has been deleted.' })
					} else {
						// don't set hasCheckedForPending
						return
					}
				}

				clearPending()

				if (newURL) {
					history.push(newURL)
				}
			} else if (pendingNotification.invalid) {
				openModal('error', null, { message: 'This notification appears to be invalid.' })
				clearPending()
			}
		} else if (emailValidation) {
			openModal('confirm', 'confirm', {
				text: emailValidation.text ? emailValidation.text : "This address seems to be invalid.",
				isError: emailValidation.status !== 200
			})

			clearActivation()
		}

		this.hasCheckedForPending = true
	}

	checkForInitialQueryValues = _ => {
		const {
			isPremium,
			openModal
		} = this.props

		if (window.initialQueryValues && window.initialQueryValues.includes('tryBusiness') && !isPremium) {
			openModal('pricing', 'pricing')

			window.initialQueryValues = null
		}
	}

	checkForCompleteOnboarding = _ => {
		const {
			currentAccount,
			userData,
			userRoles,
			openModal,
		} = this.props

		// Incomplete account
		if (userData && userRoles.admin && !currentAccount.trial_ends_at && !currentAccount.has_lifetime) {
			openModal('register', 'register', {})
		}
	}

	checkForStylesheetSwap() {
		const {
			currentAccount,
		} = this.props

		if (this.hasCheckedForStylesheetSwap) {
			return
		}

		if (currentAccount) {
			this.hasCheckedForStylesheetSwap = true

			const hasPlanningIds = [5562, 1, 6224, 290, 6028, 6029, 6080, 6724, 53, 6900, 6580]

			if (hasPlanningIds.indexOf(currentAccount.id) !== -1) {
				window.hasPlanning = true

				if (currentAccount.id === 5562) {
					window.isTkb = true
					const stylesheetElement = document.getElementById('stylesheet')
					const tkbStylesheetElement = document.getElementById('tkb-stylesheet')

					stylesheetElement.setAttribute('href', tkbStylesheetElement.getAttribute('href'))
				}
			}
		}
	}

	UNSAFE_componentWillMount() {
		const {
			history,
			openModal,
			unsubscribeData,
			clearUnsubscribeData,
			userData,
			getPlanAndCurrencyInfo,
		} = this.props

		this.checkForCompleteOnboarding()
		this.checkForStylesheetSwap()

		getPlanAndCurrencyInfo(_ => {
			this.checkForInitialQueryValues()
		})

		history.listen(e => {
			this.blockScrollResponse = true

			setTimeout(_ => {
				this.blockScrollResponse = false
			}, 1000)
		})

		this.evaluateLight()

		if (isMobile()) {
			document.addEventListener('scroll', e => {
				if (this.props.activeHeaderTab || !e.target.scrollingElement) {
					return
				}

				this.handleScroll(e.target.scrollingElement.scrollTop, e)
			}, false)

			window.addEventListener('keyboardWillShow', this.updateKeyboardHeight)
			window.addEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
			window.addEventListener('keyboardWillHide', this.updateKeyboardHeight)

			// take this off, it's not necessary.
			document.body.style.minHeight = '0px'
		}

		document.addEventListener("resume", this.handleMobileReopen, false) // mobile-only. refresh data
		window.addEventListener("focus", this.handleWindowFocus, false) // 

		if (userData) {
			setDeviceToken(userData)
		}

		setTimeout(_ => {
			toggleMobileControls(true)
			this.hasMountedWithDelay = true
		}, 1000)

		if (unsubscribeData) {
			openModal('confirm', 'confirm', {
				text: `You've been unsubscribed from 'Weekly Update' emails.`
			})

			clearUnsubscribeData()
		}

		this.startWellnessTimer()

		doDeepLink(this.props)
	}

	componentWillUnmount() {
		if (isMobile()) {
			document.removeEventListener('scroll', e => {
				if (this.props.activeHeaderTab || !e.target.scrollingElement) {
					return
				}

				this.handleScroll(e.target.scrollingElement.scrollTop, e)
			}, false)

			window.removeEventListener('keyboardWillShow', this.updateKeyboardHeight)
			window.removeEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
			window.removeEventListener('keyboardWillHide', this.updateKeyboardHeight)
			window.removeEventListener("focus", this.handleWindowFocus, false)
		} else {
			if (this.wellnessTimerInterval) {
				clearInterval(this.wellnessTimerInterval)
			}
		}

		document.body.classList.remove('dark')
	}

	componentDidMount() {
		scrollToTop()

		const {
			currentAccount,
			userData
		} = this.props

		setTimeout(_ => {
			this.setState({
				isLoaderVisible: true
			})
		}, 5)

		if (currentAccount && userData) {
			this.checkForPendingNotificationOrInvitation(true)
		}
	}

	assessForPremiumBlock = _ => {
		const {
			currentAccount,
			openModal,
		} = this.props

		if (isBlockedPremiumAccount(currentAccount)) {
			this.hasActivatedPremiumBlockModal = true

			openModal('trial-over', 'trial-over')
		}

		if (window.campaign && window.campaign === 'threeForFree') {
			delete window.campaign
			openModal('confirm', 'confirm', {
				text: `We've added three months to your free trial. You're good to go until the ${moment(currentAccount.trial_ends_at).format('Do [of] MMMM')}.`,
			})
		}
	}

	UNSAFE_componentWillUpdate = nextProps => {
		const {
			match,
			userData,
		} = this.props

		this.assessSocketIds()
		this.checkForStylesheetSwap()

		const { location } = nextProps

		const isChat = location.pathname.endsWith('/chat')

		if (isChat !== this.isChat) {
			this.isChat = isChat
		}

		doToken('get', null, response => {
			const {
				token
			} = response

			if (token && axios.defaults.headers.common['Authorization']) {
				let currentToken = axios.defaults.headers.common['Authorization'].replace('Bearer ', '')
				let newToken = token

				if (newToken !== currentToken) {
					axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken
				}
			}
		})

		if (match.params.account_slug !== nextProps.match.params.account_slug) {
			if (userData) {
				this.getAccountData(nextProps)
			}
		}
	}

	componentDidUpdate = prevProps => {
		const {
			currentAccount,
			userData
		} = this.props

		if (currentAccount && userData) {
			if (this.state.isLoaderVisible) {
				this.setState({
					isLoaderVisible: false
				})
			}

			if (!prevProps.currentAccount) {
				this.checkForCompleteOnboarding()
			}
		}

		this.evaluateLight()
	}

	componentDidCatch = (error, info) => {
		console.log(error)
		console.log(info)
		/* this.props.openModal('confirm','confirm',{
			text: 'Something fucky is going on',
			isError: true
		}) */
	}

	hasAccountJustUpgraded = (oldAccount, newAccount) => {
		return oldAccount && newAccount && oldAccount.id == newAccount.id && !oldAccount.isPremium && newAccount.isPremium
	}

	assessSocketIds = _ => {
		if (window.Echo) {
			setTimeout(_ => {
				if (window.Echo.socketId()) {
					axios.defaults.headers.common['X-Socket-ID'] = window.Echo.socketId()
				} else {
					axios.defaults.headers.common['X-Socket-ID'] = null
				}
			}, 500)
		}
	}

	updateKeyboardHeight = e => {
		const newHeight = e.keyboardHeight ? (e.keyboardHeight * scaleFactor()) : 0

		if (newHeight) {
			document.body.classList.add('keyboard-visible')
		} else {
			document.body.classList.remove('keyboard-visible')
		}

		this.props.updateKeyboardHeight(newHeight)
	}

	handleWindowFocus = _ => {
		const {
			currentAccount,
			touchAccount,
			userId,
			getUserData,
			token = null
		} = this.props

		if (currentAccount) {
			touchAccount(currentAccount.id)

			if (!isMobile() && this.lastTimeGettingAccountData) {
				const now = moment()

				const minutesSinceGettingData = now.diff(this.lastTimeGettingAccountData, 'minutes')

				if (minutesSinceGettingData > 10) {
					this.getAccountData()
					this.checkForNewChats()

					if (userId) {
						getUserData(userId, _ => { }, token)
					}
				}
			}
		}
	}

	handleMobileReopen = _ => {
		// Re-fetch data when you re-open your phone.
		// This gets called twice on Android occasionally, resulting in all the dumb logouts.
		setTimeout(_ => {
			const {
				userId,
				getUserData,
				token = null
			} = this.props

			if (!userId) {
				return
			}

			this.getAccountData()
			getUserData(userId, _ => { }, token)
		}, 10)
	}

	handleCampaign = campaign => {
		if (!campaign) {
			return
		}

		const {
			openModal,
			currentAccount,
			folderChain,
			history
		} = this.props

		let hasFoundCampaign = false

		switch (campaign) {
			case 'createProject':
				hasFoundCampaign = true

				if (currentAccount) {
					openModal('create', 'project', {
						account_id: currentAccount.id,
						folderChain: folderChain
					})
				}

				break
			case 'invite':
				hasFoundCampaign = true
				openModal('invite', 'invite')

				break
			case 'planning':
				hasFoundCampaign = true

				history.push(`/${currentAccount.slug}/planning`)
				break
		}

		if (hasFoundCampaign) {
			delete window.campaign
		}
	}

	getAccountData = (props = this.props, callback = _ => { }) => {
		const {
			getAccountData,
			match,
			userId,
			token = null,
			campaign,
			currentAccount
		} = props

		if (currentAccount) {
			this.handleCampaign(campaign)
		}

		this.lastTimeGettingAccountData = moment()

		getAccountData(match.params.account_slug, campaign, false, _ => {
			if (!this.hasActivatedPremiumBlockModal) {
				this.assessForPremiumBlock()
			}

			// We can run this a second time - it clears the variable if it's found
			this.handleCampaign(campaign)

			if (callback) {
				callback()
			}
		}, token)
	}

	checkForNewChats = _ => {
		const {
			checkForNewChats
		} = this.props

		checkForNewChats()
	}

	evaluateLight = _ => {
		const {
			tempForcedUiColourState,
			userData
		} = this.props

		const {
			isLight
		} = this.state

		let shouldSetToLight = userData && !userData.show_dark_ui

		if (tempForcedUiColourState !== -1) {
			shouldSetToLight = !tempForcedUiColourState
		}

		if (shouldSetToLight) {
			document.body.classList.add('light')
			document.body.classList.remove('dark')

			if (!isLight) {
				this.setState({
					isLight: true
				})
			}
		} else {
			document.body.classList.remove('light')
			document.body.classList.add('dark')

			if (isLight) {
				this.setState({
					isLight: false
				})
			}
		}
	}

	toggleSidebar = _ => {
		this.setState({
			sidebarHidden: !this.state.sidebarHidden
		})
	}

	// this is doubled up in mobile/footer-buttons, but I'm not sure how to share the logic.
	previousScrollTop = 0
	hasDebouncedInitialScroll = false
	hasMountedWithDelay = false

	handleScroll = (scrollTop, e) => {
		if (!isMobile() || !e || this.blockScrollResponse || !this.hasMountedWithDelay) {
			return
		}

		const element = e.currentTarget
		const distanceFromBottom = element.scrollHeight - (element.scrollTop + element.clientHeight)
		const scrollDelta = this.previousScrollTop - scrollTop

		const direction = scrollDelta > 0 ? 'up' : 'down'

		// on page load, it throws in some huge scroll.
		if (!this.hasDebouncedInitialScroll) {
			this.hasDebouncedInitialScroll = true
		} else {
			if (scrollTop < 80) {
				toggleMobileControls(true)
			}

			if (direction === 'up') {
				// scrolling up
				if (scrollTop > 80 && (!distanceFromBottom || distanceFromBottom > 100)) {
					toggleMobileControls(true)
				}
			} else {
				// scrolling down
				if (scrollTop > 80) {
					toggleMobileControls(false)
				}
			}
		}

		this.previousScrollTop = scrollTop
	}

	getContext = _ => {
		const {
			currentAccount,
			userData,
			userRoles
		} = this.props

		let shouldUpdateContextObject = !this.contextObject

		if (!shouldUpdateContextObject) {
			if (currentAccount != this.contextObject.account || userData != this.contextObject.user || userRoles != this.contextObject.roles) {
				shouldUpdateContextObject = true
			}
		}

		if (shouldUpdateContextObject) {
			this.contextObject = {
				account: currentAccount,
				user: userData,
				roles: userRoles
			}
		}
	}

	startWellnessTimer = () => {
		if (!this.wellnessTimerInterval && !isMobile()) {
			const intervalCallback = () => {
				const thisHour = moment().format('H')

				if (this.wellnessLastCheckedHour !== thisHour) {
					this.wellnessLastCheckedHour = thisHour

					const {
						userData,
						getWellness
					} = this.props

					if (userData) {
						getWellness(userData)
					}
				}
			}

			intervalCallback()

			this.wellnessTimerInterval = setInterval(() => {
				intervalCallback()
			}, 60000)
		}
	}

	render() {
		const {
			isLoaderVisible,
			isLoadingInitData,
			isLight,
			sidebarHidden,
		} = this.state

		const {
			userData,
			currentAccount,
			folderChain,
			match,
			history,
			userRoles,
			activeHeaderTab,
			activeChats,
			chatBehaviourTrigger,
			isPremium,
			forceHideActivation,
			openModal,
			wellnessData,
			userId
		} = this.props

		let thisUrl = match.url

		this.getContext()

		if (userId && (currentAccount || isLoadingInitData)) {
			const logoSrc = `/images/logo${isLight ? '' : '-white'}.png`

			return (
				<div>
					<div className={`account-loader ${isLoaderVisible ? 'visible' : ''}`}>
						<div>
							<img src={document.base + logoSrc} alt="Hassl logo" />
							<h2>
								One sec!
							</h2>
						</div>
					</div>
					{(isMobile() && !isCordova) ?
						<ScreenCover />
						: null}
					<div className={`account-container ${!isLoaderVisible ? 'visible' : ''}`}>
						{
							(currentAccount && userData) ?
								<MainContext.Provider value={this.contextObject}>
									<Socket
										account={currentAccount}
										wellnessData={wellnessData}
									/>
									<div>
										<div className={`main ${this.isChat ? 'is-chat' : ''}`}>
											<ErrorBoundary openModal={openModal}>
												{!this.isChat ?
													<Header
														match={match}
														history={history}
														sidebarHidden={sidebarHidden}
														userData={userData}
														handleScroll={this.handleScroll}
														chatBehaviourTrigger={chatBehaviourTrigger}
														currentAccount={currentAccount}
													/>
													: null}
												<Main
													userData={userData}
													sidebarHidden={sidebarHidden}
													toggleSidebar={this.toggleSidebar}
													currentAccount={currentAccount}
													folderChain={folderChain}
													isGuest={userRoles.guest}
													userRoles={userRoles}
													thisUrl={thisUrl}
													activeHeaderTab={activeHeaderTab}
													activeChats={activeChats}
													chatBehaviourTrigger={chatBehaviourTrigger}
													isPremium={isPremium}
													forceHideActivation={forceHideActivation}
													isChat={this.isChat}
												/>
											</ErrorBoundary>
											{
												(userData.chats && !this.isChat) ?
													<Dock />
													: null
											}
											<MobileFooter />
										</div>
									</div>
								</MainContext.Provider>
								: null
						}
					</div>
				</div>
			)
		} else {
			return (
				<Redirect to={'/'} />
			)
		}
	}
}

const mapStateToProps = state => {
	return {
		userId: state.auth.userId,
		userData: getCurrentUser(state),
		token: state.auth.token,
		currentAccount: getCurrentAccount(state),
		folderChain: state.account.folderChain,
		pendingInvitation: state.auth.pendingInvitation,
		pendingNotification: state.auth.pendingNotification,
		emailValidation: state.auth.emailValidation,
		allEntities: state.account.entities,
		isGuest: isCurrentUserGuest(state),
		activeHeaderTab: state.account.activeHeaderTab,
		keyboardHeight: state.account.keyboardHeight,
		activeChats: state.auth.activeChats || [],
		userRoles: getUserRoles(state),
		chatBehaviourTrigger: state.account.chatBehaviourTrigger,
		isPremium: isPremium(state),
		forceHideActivation: state.auth.forceHideActivation,
		tempForcedUiColourState: state.auth.tempForcedUiColourState,
		unsubscribeData: state.auth.unsubscribeData,
		modal: state.modal,
		wellnessData: state.auth.wellnessData
	}
}

export default withRouter(connect(mapStateToProps, {
	getAccountData,
	getUserData,
	openModal,
	clearPending,
	openHeaderTab,
	updateKeyboardHeight,
	touchAccount,
	clearActivation,
	clearUnsubscribeData,
	cancelPremium,
	getPlanAndCurrencyInfo,
	checkForNewChats,
	getWellness,
	purgeData
})(App))
